import { useState } from "react";

import { useSearchGpUsersForDeal } from "@vega-api/generated/coinvest-deal-permission/coinvest-deal-permission";
import { useDebounce } from "@vega-core/utils/useDebounce";

import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_SEARCH_STALE_TIME,
  SEARCH_DEBOUNCE_DELAY_MS,
} from "../../../constants/searchConstants";

type UseGpUsersForDealSearchParams = {
  dealId: string;
};

export const useGpUsersForDealSearch = ({
  dealId,
}: UseGpUsersForDealSearchParams) => {
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebounce(
    searchValue,
    SEARCH_DEBOUNCE_DELAY_MS,
  );

  const searchQuery = debouncedSearchValue.trim();
  const { data = [], isPending } = useSearchGpUsersForDeal(
    dealId,
    {
      pageSize: DEFAULT_PAGE_SIZE,
      ...(searchQuery ? { searchQuery } : {}),
    },
    {
      query: {
        enabled: !!searchQuery,
        select: (response) => response.data,
        staleTime: DEFAULT_SEARCH_STALE_TIME,
      },
    },
  );

  return {
    searchValue,
    setSearchValue,
    searchQuery,
    data,
    isPending,
  };
};
